const FALLBACK_DELAY = 8000;

/**
 * Pages prerendered by scripts/prerender.js show a static snapshot (#prerendered) while the
 * app renders into a hidden #root. Swap them once the app shows a real page (no PageLoader
 * left), or after FALLBACK_DELAY at the latest, so the visitor never sees a blank loader.
 */
export function handOffPrerenderedPage() {
  const snapshot = document.getElementById('prerendered');
  const root = document.getElementById('root');
  if (!snapshot || !root) return;

  const isReady = () => root.childElementCount > 0 && !root.querySelector('[data-page-loader]');
  const observer = new MutationObserver(() => {
    if (isReady()) requestAnimationFrame(swap);
  });
  const timer = setTimeout(swap, FALLBACK_DELAY);
  function swap() {
    observer.disconnect();
    clearTimeout(timer);
    snapshot?.remove();
    document.getElementById('prerender-style')?.remove();
  }
  observer.observe(root, { childList: true, subtree: true });
}
